import {
  ConfirmationBox,
  HeadingGroup,
  ModalLayout,
  OffCanvasLayout,
  Pagination,
  SearchFilters,
  Table,
} from "@wac-ui-dashboard/wac_component_library";
import React from "react";
import { FaSort } from "react-icons/fa";
import { ImageCard } from "../../Global/ImageCard";
import OrderColumn from "../../Global/OrderColumn/index";
import EmptyData from "../../Global/EmptyData";
import useGiftCards from "./useGiftCards";
import AddGiftCards from "./AddGiftCards";

const GiftCards = () => {
  const {
    isLoading,
    imageData,
    isFetching,
    giftCardList,
    showEditModal,
    giftCardState,
    showImageModal,
    paginationOptions,
    handleEditColumnsClick,
    updateGiftCardFields,
    handleDeleteModal,
    handleDelete,
    handleClose,
    handleCreateClick,
    handlePagination,
    handleClearClick,
    handleEditAction,
    closeImageModal,
    handlePageSize,
    handleSearch,
    handleSort,
    refetch,
    getRow,
  } = useGiftCards();
  return (
    <div>
      <HeadingGroup
        title={"Gift Cards"}
        className={`pro-mb-4`}
        // buttonTitle={giftCardList?.data?.create_permission && "Create"}
        buttonTitle={"Create"}
        handleClick={handleCreateClick}
      />
      <div className="col-auto pro-pt-3 pro-pb-6">
        <SearchFilters
          onSearchInput={handleSearch}
          loading={isLoading}
          SearchIcon={
            <span className="material-symbols-outlined"> search </span>
          }
          showClearFilters={giftCardState?.search === "" ? false : true}
          handleClear={handleClearClick}
          searchInputProps={{ value: giftCardState?.search }}
          handleActionClick={handleEditColumnsClick}
        />
        {giftCardList?.data?.data?.length === 0 ? (
          <EmptyData />
        ) : (
          <Table
            multiSelect={false}
            data={giftCardList?.data?.data || []}
            uniqueID={"id"}
            fields={giftCardList?.data?.fields || []}
            SortIcon={<FaSort />}
            editIcon={<span className="material-symbols-outlined">edit</span>}
            deleteIcon={
              <span className="material-symbols-outlined">delete</span>
            }
            handleSort={handleSort}
            getRow={getRow}
            clear={giftCardState?.clearSelection}
            loading={isFetching}
            perpage={giftCardState?.currentPageSize}
            assignable={false}
            handleEdit={handleEditAction}
            handleDelete={handleDeleteModal}
            deletable={giftCardList?.data?.delete_permission}
            editable={giftCardList?.data?.edit_permission}
            // showCheckBox={
            //   giftCardList?.data?.delete_permission ||
            //   giftCardList?.data?.edit_permission
            // }
            showCheckBox={true}
          />
        )}

        {giftCardList?.data?.data?.length > 0 && (
          <Pagination
            currentPage={giftCardState?.currentPage}
            totalPageCount={Math.ceil(
              giftCardList?.data?.total_count / giftCardState.currentPageSize
            )}
            defaultValue={paginationOptions?.filter(
              (item) => item?.value === giftCardState?.currentPageSize
            )}
            onPageChange={handlePagination}
            options={paginationOptions}
            onActionChange={handlePageSize}
            center
          />
        )}
        <ModalLayout
          show={giftCardState?.showDeleteModal}
          handleClose={handleDeleteModal}
        >
          <div className="pro-m-5">
            <ConfirmationBox
              title={"Are you sure to delete the selected Gift Card ?"}
              subTitle={"This action can't be undo "}
              cancelText={"No"}
              cancelAction={handleDeleteModal}
              submitText={"Yes"}
              submitAction={handleDelete}
              isRight={true}
            />
          </div>
        </ModalLayout>

        <ModalLayout
          show={showEditModal}
          handleClose={handleEditColumnsClick}
          backdrop="static"
        >
          <div className="pro-m-5">
            <OrderColumn
              title={"Choose which columns you see"}
              refetchData={refetch}
              tableFields={giftCardList?.data?.fields || []}
              moduleId={giftCardList?.data?.module_id}
              updateData={updateGiftCardFields}
            />
          </div>
        </ModalLayout>
        <OffCanvasLayout
          show={giftCardState?.showCreateModal}
          handleClose={handleClose}
          title={giftCardState?.isEdit ? "Update Gift Card" : "Add Gift Card"}
          backdrop={"static"}
        >
          <AddGiftCards
            refetch={refetch}
            handleCreateClick={handleCreateClick}
          />
        </OffCanvasLayout>

        <ModalLayout
          show={showImageModal}
          handleClose={closeImageModal}
          backdrop="static"
        >
          <ImageCard data={imageData} handleClose={closeImageModal} />
        </ModalLayout>
      </div>
    </div>
  );
};

export default GiftCards;
